import React from 'react';
import PropTypes from 'prop-types';
import ATypeTestRows from './TestPaperRows/ATypeTestRow';
import BTypeTestRows from './TestPaperRows/BTypeTestRow';
import CTypeTestRows from './TestPaperRows/CTypeTestRow';
import DTypeTestRows from './TestPaperRows/DTypeTestRow';
import ETypeTestRows from './TestPaperRows/ETypeTestRow';

function TestPaperPDF({ tab, config, generatedPaper }) {
  const typeKeys = generatedPaper?.map(type => type.type);

  return (
    <div
      className="pdf-content px-[1.2cm] w-[749px] flex flex-col justify-start bg-[#fff] rounded-xl"
      style={{
        height: 'auto',
        overflow: 'visible',
        pageBreakInside: 'avoid',
        pageBreakAfter: 'always',
      }}
    >
      <div className="flex gap-2 justify-between items-center w-full h-[65px] border-b border-[#CBD5E1]">
        <div className="flex justify-start gap-2 items-center">
          {config.orgLogoFile !== null && config.orgLogoUrl !== null && (
            <img
              src={config.orgLogoUrl}
              alt="Logo"
              style={{ maxWidth: '95px', maxHeight: '38px' }}
            />
          )}
          <div className="">
            <div className="text-[9px]">
              <span className="text-[#0AAAED]">{config?.orgName}</span>&nbsp;•
              <span>{config?.className}</span>&nbsp;•
              <span>{config?.teacherName}</span>
            </div>
            <div className="text-[12px] font-[700]">{config?.paperName}</div>
          </div>
        </div>
        <div className="flex text-[#A9B6CA] items-center justify-center w-[132px] h-[40px] text-[9px] bg-[#F0F5F9]">
          이름
        </div>
      </div>
      <div
        className="break-all w-full h-[auto] py-[20px]"
        style={{
          columnCount: 2 /* 두 개의 열로 나누기 */,
          columnGap: '2.5rem' /* 열 간격 설정 */,
          textAlign: 'justify' /* 텍스트 양쪽 정렬 */,
        }}
      >
        {generatedPaper?.length >= 1 && (
          <>
            {typeKeys?.includes('A') && (
              <ATypeTestRows
                vocaList={generatedPaper?.find(type => type.type === 'A')}
                startNo={
                  generatedPaper?.find(type => type.type === 'A')?.startNo
                }
                tab={tab}
              />
            )}
            {typeKeys?.includes('B') && (
              <BTypeTestRows
                vocaList={generatedPaper?.find(type => type.type === 'B')}
                startNo={
                  generatedPaper?.find(type => type.type === 'B')?.startNo
                }
                tab={tab}
              />
            )}
            {typeKeys?.includes('C') && (
              <CTypeTestRows
                vocaList={generatedPaper?.find(type => type.type === 'C')}
                startNo={
                  generatedPaper?.find(type => type.type === 'C')?.startNo
                }
                tab={tab}
              />
            )}
            {typeKeys.includes('D') && (
              <DTypeTestRows
                vocaList={generatedPaper?.find(type => type.type === 'D')}
                startNo={
                  generatedPaper?.find(type => type.type === 'D')?.startNo
                }
                tab={tab}
              />
            )}
            {typeKeys.includes('E') && (
              <ETypeTestRows
                vocaList={generatedPaper?.find(type => type.type === 'E')}
                startNo={
                  generatedPaper?.find(type => type.type === 'E')?.startNo
                }
                tab={tab}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}

TestPaperPDF.propTypes = {
  tab: PropTypes.string,
  config: PropTypes.object,
  generatedPaper: PropTypes.array,
  startNumbers: PropTypes.array,
  contentRef: PropTypes.objectOf(PropTypes.any),
};

export default TestPaperPDF;
